const prefix = require('../../../package.json').name + '_'
class Storage {
  constructor(config = {}) {
    this.version = "1.0.0";
    // this.prefix = prefix;
    this.setOptions(config);
  }

  get prefix() {
    return this.options.prefix;
  }

  get driver() {
    switch (this.options.driver) {
      case "local":
      default:
        return window.localStorage;
      case "session":
        return window.sessionStorage;
    }
  }

  setOptions(config = {}) {
    const options = Object.assign(
      {
        prefix,
        driver: "local"
      },
      config
    );
    this.options = Object.freeze(options);
  }

  addPrefix(key) {
    return `${this.options.prefix || ""}${key}`;
  }

  removePrefix(key) {
    const re = new RegExp(`^${this.options.prefix || ""}`);
    return key.replace(re, "");
  }

  set(key, data, ttl) {
    if (!this._isStr(key)) return;
    const time = Date.now();
    const expire = Number(ttl) || 0;
    const json = JSON.stringify({ time, expire, data });
    this.driver.setItem(this.addPrefix(key), json);
  }

  get(key) {
    if (!this._isStr(key)) return;
    const json = this.driver.getItem(this.addPrefix(key)) || "{}";
    const parsed = JSON.parse(json) || {};
    const { time, expire, data } = parsed;
    if (this._isExpired(time, expire)) this.delete(key);
    return data;
  }

  // remove saved data
  delete(key) {
    if (!this._isStr(key)) return;
    this.driver.removeItem(this.addPrefix(key));
  }

  clear(force = false) {
    if (force) {
      this.driver.clear();
    } else {
      const keys = Object.keys(this.driver).filter(key =>
        key.startsWith(this.options.prefix || "")
      );
      keys.forEach(key => this.delete(this.removePrefix(key)));
    }
  }

  _isStr(str) {
    return str && typeof str === "string";
  }

  _isExpired(time, expire) {
    if (!time || !expire) return false;
    const now = Date.now();
    const secs = (now - time) / 1000;
    return secs >= expire ? true : false;
  }
}

export default new Storage();
